var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1718 14.8293L14.8287 9.17241M7.05086 11.2935L5.63664 12.7077C4.07455 14.2698 4.07409 16.8027 5.63619 18.3648C7.19829 19.9269 9.7317 19.9264 11.2938 18.3643L12.7065 16.9502M11.2929 7.05049L12.7071 5.63628C14.2692 4.07418 16.8016 4.07446 18.3637 5.63656C19.9258 7.19865 19.9257 9.73134 18.3636 11.2934L16.9501 12.7076",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkicon);
export default __webpack_public_path__ + "static/media/linkicon.7e0d4d4f706dd12705281043755a74c6.svg";
export { ForwardRef as ReactComponent };